// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "webpacked-" + chunkId + "-" + "945b3ac45b2932b5" + ".css";
};